import { CommonModule } from "@angular/common"
import {
	booleanAttribute,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	Output,
	TemplateRef,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { EventsService } from "@app/services/events.service"
import { ModalService } from "@app/services/modal.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, Icon } from "@app/utils/utils.component"

@Component({
	selector: "app-modal-wrap",
	imports: [COMMON_IMPORTS, CommonModule, LangValPipe, BtnExtComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./modal-wrap.component.html",
	styles: `
		.enter-animation {
			animation: slide-fade 0.5s;
		}
		@keyframes slide-fade {
			from {
				opacity: 0.9;
				transform: translateY(-100px);
			}
			to {
				opacity: 1;
				transform: translateY(0);
			}
		}
	`,
})
export class ModalWrapComponent {
	@ViewChild("container") container?: TemplateRef<any>
	@ViewChild("modalDialog") modalDialog?: ElementRef
	@Output() onClose = new EventEmitter()
	zIndex: number = 0
	@Input() modalWrapperClass: string = "modal-full-width"
	@Input() title: string = ""
	@Input({ transform: booleanAttribute }) hasExit: boolean = false
	self: any = this
	ref: any = null

	constructor(
		public eventsService: EventsService,
		public modalService: ModalService
	) {}

	ngOnInit() {
		this.zIndex = 2000 + 10 * this.modalService.onInit(this)
	}
	ngAfterViewInit() {
		this.modalService.openCloseSubj.next({ ref: this.container, isOpen: true })
	}
	ngOnDestroy() {
		this.modalService.openCloseSubj.next({ isOpen: false })
		this.modalService.onDestroy(this)
	}
	innerClick(ev: any) {
		ev.stopPropagation()
		this.eventsService.onDocClick()
	}
	close() {
		this.onClose.emit()
	}

	headerMouseDown(ev: MouseEvent) {
		this.eventsService.onDocClick()
		this.eventsService.dragMouseDown(ev, {
			affectedObj: this.modalDialog?.nativeElement,
			xStyleAttrName: "left",
			yStyleAttrName: "top",
		})
	}
	headerMouseUp(ev: MouseEvent) {
		this.eventsService.dragMouseUp(ev)
	}
	headerClick(ev: MouseEvent) {
		ev.stopImmediatePropagation()
	}
}
